export function editAppointment(
  appointmentId: string,
  patientId: string,
  goToRouteFuntion: () => void
) {
  localStorage.setItem('appointmentId', appointmentId);
  localStorage.setItem('patientId', patientId);
  goToRouteFuntion();
}
